export default "__VITE_ASSET__bqGF9wUn__"